<template>
  <div :class="{ minimap: true }">
    <div>
      <object type="image/svg+xml" :data="map" ref="svg" @load="svgload">
      </object>
    </div>

    <div class="overlay">
      <svg :class="{ overlay: true, single }" viewBox="0 0 1254 80">
        <circle
          v-for="point in points"
          :key="point.id"
          :cx="point.point.x"
          :cy="point.point.y"
          :r="points.length === 1 ? 7.5 : 3.5"
          :style="pointStyle(point)"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import map from "../assets/Getty_mini_map_V3.svg";

export default {
  name: "StripMap",
  props: {
    hovering: null,
    locations: Array,
    styleOverride: Object,
    circleColor: String
  },
  data() {
    return {
      path: false,
      map
    };
  },
  methods: {
    pointStyle(point) {
      const style = {
        fillOpacity: 1,
        fill: this.circleColor,
        stroke: "white",
        strokeWidth: 1.5,
        ...this.styleOverride
      };

      // Override when point is hovering
      if (point.id === this.hovering) {
        style.fill = "#ffe857";
        style.fillOpacity = 1;
      }

      return style;
    },

    svgload() {
      let svg = this.$refs.svg.getSVGDocument();
      let path = svg.getElementById("sunset");
      this.path = path;
    }
  },
  computed: {
    pathLength() {
      if (!this.path) return false;

      return this.path.getTotalLength();
    },

    points() {
      if (!this.path) return [];
      let length = this.path.getTotalLength();
      let scale = d3
        .scaleLinear()
        .domain([
          0.02,
          0.19918,
          0.26183,
          0.38115,
          0.51997,
          0.65814,
          0.73836,
          0.80615,
          0.95458,
          0.99233
        ])
        .range([
          0,
          0.15275,
          0.23518,
          0.38492,
          0.54032,
          0.68371,
          0.76841,
          0.82616,
          0.97169,
          1.0
        ])
        .clamp(true);

      return this.locations
        .map(l => ({
          ...l,
          point: this.path.getPointAtLength(scale(l.position) * length)
        }))
        .sort((a, b) => {
          if (a.id === this.hovering) return 1;
          if (b.id === this.hovering) return -1;
          return 0;
        });
    },

    single() {
      return this.points.length === 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.minimap {
  width: 100%;
  position: relative;
  background: #686868;
  // max-height: 80px;

  svg {
    width: 100%;
    // max-height: 80px;
  }

  object {
    margin-bottom: -3px;
    // max-height: 80px;
  }
}

.overlay {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  z-index: 10;

  svg {
    width: 100%;
  }

  &.single:hover {
    circle {
      stroke-width: 3px !important;
      fill: $light-gold !important;
      stroke: $light-gold !important;
    }
  }
}
</style>
